import React from "react";
import { User } from "../components/User/User";

export const UserPage = () => {
  return <User />;
};
